import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trash, ClockCounterClockwise } from "@phosphor-icons/react";
import { money } from "./shared";

const LABEL = { eii: "EII", sure: "SURE", rd: "R&D" };
const HEADLINE = {
  eii: (r) => `${money(r.claimable_credit)} claimable`,
  sure: (r) => `${money(r.refund_amount)} refund`,
  rd: (r) => `${money(r.total_benefit)} benefit`,
};

export default function TaxHistory({ refreshKey }) {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    const r = await api.get("/tax/history");
    setItems(r.data.items || []);
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  const del = async (id) => {
    if (!window.confirm("Delete this saved calculation?")) return;
    await api.delete(`/tax/history/${id}`);
    load();
  };

  return (
    <div className="glass rounded-2xl p-6" data-testid="tax-history">
      <div className="flex items-center gap-2 mb-4">
        <ClockCounterClockwise size={18} className="text-[#FFB020]" />
        <div className="eyebrow">Saved calculations</div>
      </div>
      {items.length === 0 ? (
        <div className="text-white/40 text-sm">No calculations saved yet. Each calculation is stored here with an audit ID for your accountant.</div>
      ) : (
        <div className="space-y-2">
          {items.map((it) => (
            <div key={it.calculation_id} className="flex items-center justify-between rounded-xl bg-black/25 border border-white/5 px-4 py-3" data-testid={`history-${it.calculation_id}`}>
              <div className="flex items-center gap-3">
                <span className="px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider bg-[#FFB020]/15 text-[#FFB020]">{LABEL[it.relief_type] || it.relief_type}</span>
                <div>
                  <div className="text-sm font-semibold">{HEADLINE[it.relief_type] ? HEADLINE[it.relief_type](it.results) : ""}</div>
                  <div className="text-[11px] text-white/45 mono">{(it.timestamp || "").slice(0, 10)} · {it.calculation_id.slice(0, 8)}</div>
                </div>
              </div>
              <button onClick={() => del(it.calculation_id)} className="text-white/40 hover:text-[#E63946]" data-testid={`del-history-${it.calculation_id}`}><Trash size={15} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
